// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-content h1,.nuxt-content h2,.nuxt-content h3,.nuxt-content h4,.nuxt-content h5,.nuxt-content h6{margin-top:.8rem;margin-bottom:.5rem}.nuxt-content p,.nuxt-content ul{font-size:1.25rem;line-height:1.6}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
